import { createBrowserHistory } from 'history';
export const history = createBrowserHistory();
// httpService.setupInterceptors(store, history);